import axios from 'axios';
import store from '@/store';
import router from '@/router';

export default {
	install(Vue) {
		async function ApiCaller({
			method = 'GET',
			path,
			params,
			data,
		}) {
			// const timestamp = Date.now();
			// store.dispatch('addLoadingSegment', timestamp);

			try {
				const response = await axios({
					method,
					url: `${process.env.VUE_APP_API_BASE_URL}${path}`,
					params,
					data,
				});

				return response;
			} catch (error) {
				if ([401, 404].includes(error.response.status) && store.getters['auth/isAuthenticated']) {
					await store.dispatch('auth/removeAuthentication');
					router.push({ name: 'Login' });
					Vue.notify({
						type: 'warn',
						title: 'Time out',
						text: 'You were automatically logged out',
					});
				}

				throw new Error(error);
			} finally {
				// store.dispatch('removeLoadingSegment', timestamp);
			}
		}

		Vue.callAPI = ApiCaller;
		Vue.prototype.$callAPI = ApiCaller;
	},
};
